import { render, staticRenderFns } from "./Batches.vue?vue&type=template&id=fdcda408&scoped=true&lang=true&"
import script from "./Batches.vue?vue&type=script&lang=js&"
export * from "./Batches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdcda408",
  null
  
)

export default component.exports